<template>
    <split-pane  :min-percent='10' :default-percent='14' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
            <el-tree :data="orgData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto', 'margin-top':'2px'}"
                        highlight-current
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                    
                    <span   style="font-size:14px;font-weight:600;color:#409efe"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:16px;"></i>{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;"></i> {{ node.label}} </span>
                    </span>
                </template>
            </el-tree>    
        </template>
        <template slot="paneR">
            <div class="ve-list-page ve-list-page--embedded ve-list-page--pane">
            <div style="background:#fff;  " class="ve-list-page__body">
                <div style="display:flex;line-height:30px;min-width:1300px;width:100%;border-bottom:2px solid #389;padding-top:3px;height:38px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;font-weight:600"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;font-weight:600">{{ $LANG('0084', '新增人员') }}</span></el-link>
                    <div style="font-size:12px;margin-right:5px;margin-left:11px">{{ $LANG('0298', '字段') }}</div>
                    <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:120px;  ">
                        <span v-for="item in tabCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="$LANG('1692', '请输入查询值')" ref="refqry" v-model="txtparam" size="small" style="width:300px; height:30px; ">
                        <el-select v-model="oper" slot="prepend"  size="small" style="width:90px;  ">
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> 
                    <div style="line-height:30px;font-size:12px;margin-left:15px;margin-right:5px;font-weight:600">{{ $LANG('1983', '已离职') }}</div>
                    <el-checkbox @change="chkChange" true-label="Y" false-label="N" v-model="v_stfg"></el-checkbox>
                    <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                    <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
                </div>
                
                <div style="width:100%" class="ve-list-page__body">
                    <div class="ve-list-page__table">
                    <ve-table :columns="vueCol" 
                            :table-data="tabData" 
                            :columnHiddenOption="columnHiddenOption"
                            style="margin-top:0px; "
                            :border-around="true"
                            :border-x="true" 
                            :border-y="true" 
                            :fixed-header="true"
                            row-key-field-name="IDSEQ"
                            :row-style-option="rowStyleOption"
                            :cell-style-option="cellStyleOption"
                            :max-height="tabHeight" 
                            :virtual-scroll-option="virtualScrollOption"
                            :scroll-width="0"                  
                            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                            :column-width-resize-option="columnWidthResizeOption"
                            :cellSelectionOption="{enable: false,}"
                            id="hr_employee"
                            ref="tableRef">
                    </ve-table>
                    </div>
                    <div style="margin-top:2px" class="ve-list-page__pagination">
                        <ve-pagination
                            :total="dataCount"
                            :page-index="pageIndex"
                            :page-size="pageSize"
                            :page-size-option="pageList"
                            @on-page-number-change="pageNumberChange"
                            @on-page-size-change="pageSizeChange"
                        />
                    </div>
                </div>
                <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addModal" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1183', '人员资料明细') }}</span>
                    </div> 
                    <span v-if="activeTab=='tab01'" >
                        <div style="height:84vh;overflow-y:auto">
                            <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                                <div class="one-toolbar">
                                    <span class="spanRow"> {{gpitem.gpnm}} </span>
                                </div>
                                <Form ref="addForm" :model="formCol" :label-width="110"  :rules="ruleValidate"  label-position="right" inline >                           
                                    <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                        <FormItem :label="$translate.getColTitle(item, $store.state.lang)" :prop="item.FLDNO" v-if="item.FHIDE==='N'" :class=" 'item-width'">
                                            <el-date-picker size="medium" :disabled="readFlag" type="date"  v-if="item.EDCSS==='date'" v-model="formCol[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>     
                                            <el-checkbox :disabled="readFlag" size="medium" v-else-if="item.EDCSS==='checkbox'" true-label="Y" border false-label="N" v-model="formCol[item.FLDNO]" style="width:100%"> &nbsp;</el-checkbox> 
                                            <el-select  size="medium" :disabled="readFlag" v-else-if="item.FLDNO==='SEX'"  v-model="formCol[item.FLDNO]" style="width:100%">
                                                <el-option  :label="$LANG('2048', '男')" value="M"></el-option>
                                                <el-option  :label="$LANG('2045', '女')" value="F"></el-option>
                                            </el-select>
                                            <el-cascader size="medium" v-else-if=" item.FLDNO==='CTRYNO'"  style="width:100%;height:300px" :placeholder="$LANG('1784', '可通过关键字查找或选择')"
                                                v-model="formCol[item.key]" 
                                                clearable
                                                :disabled="readFlag"
                                                filterable
                                                :options="areaArr">
                                            </el-cascader>

                                            <el-select size="medium" :disabled="readFlag" v-else-if="item.FLDNO==='DEPTNO'"  style="width:100%" ref="refdept" :placeholder="$LANG('1687', '请选择部门')" v-model="formCol[item.FLDNO]" >
                                                <el-option v-for="(item,index) in deptArr" :key="index" :value="item.CODE" :label="item.CNAME"  >   </el-option>
                                            </el-select>
                                            <el-select v-else-if="item.EDCSS=='select'" filterable size="medium" v-model="formCol[item.FLDNO]" style="width:100%; "> 
                                                <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                            </el-select> 
                                            <el-input size="medium" type="text" v-else :disabled="item.DISABLED==='Y'?true:false ||readFlag "  v-model="formCol[item.FLDNO]"></el-input>
                                        </FormItem>
                                    </span>                           
                                </Form>
                            </span>
                            <div class="one-toolbar">
                                <span  class="spanRow">{{ $LANG('0667', '培训记录') }}</span>
                                <el-button @click="dtlAdd" size="mini" :disabled="readFlag" type='text' style="color:#fff;margin-left:15px">【 <i class="iconfont icon-xinzeng" style="margin-right:5px"></i>{{ $LANG('0095', '新增记录') }} 】</el-button>
                            </div>
                            <!-- 明细资料 -->
                            <el-table  :data="dtlData" 
                                border                     
                                size="small"
                                :height="300" 
                                :row-key="getDtlKey"
                                :row-class-name="tabRowClass"
                                :header-cell-style="headStyle"
                                @row-click="getRowClick"
                                cell-class-name="clearPadding"
                                style="margin-top:-8px;margin-bottom:5px"
                                ref="refdtl"
                                class="custom-table-border"
                                highlight-current-row > 
                                <el-table-column type="index" :label="$LANG('0310', '序号')" width="60"></el-table-column>
                                <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                                    :prop="item.key"
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                                  
                                    :sortable="item.sortable=='N'&&item.edcss!=='checkbox' "
                                    :min-width="item.width">
                                    <template slot-scope="scope">
                                        <span v-if ="readFlag" >
                                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                            <span v-else v-text="scope.row[item.key]"></span>
                                        </span>
                                        <span v-else >
                                            <el-select filterable @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="scope.$index+item.key" v-if="item.edcss=='select'" size="mini" v-model="scope.row[item.key]" style="width:100%; "> 
                                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                            </el-select> 
                                            <el-date-picker @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="scope.$index+item.key" size="mini"  type="date"  v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                                            <el-checkbox  true-label="Y" false-label="N" :ref="'pos'+scope.$index+item.key"   v-else-if="item.edcss=='checkbox'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-checkbox> 
                                            <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                            <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                                        </span>
                                    </template> 
                                </el-table-column>    
                                <el-table-column
                                    fixed="right"
                                    :label="$LANG('0330', '操作')"
                                    align="center"
                                    width="70">
                                    <template slot-scope="scope">
                                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                        <el-link :disabled="readFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:10px;margin-right:2px;">{{ $LANG('0131', '删除') }}</span></el-link>
                                    </template>
                                </el-table-column>  
                            </el-table> 
                            <div class="one-div" style="height:28px">
                                <span  class="oneRow">{{ $LANG('1856', '（ 建议是PDF、或图片格式）') }}</span>
                  
                            </div>
                            <div style="margin-top:5px;height:150px;overflow-y:auto;" >
                                <Upload
                                    ref="upload"
                                    name="upfile"
                                    :data="uploadData"
                                    :show-upload-list="false"
                                    :before-upload="(file) =>beforeImgFile(file,'PDF')"
                                    :on-success="successImgFile"
                                    :on-progress="handleProgress"
                                    :max-size="10240"
                                    :on-exceeded-size="handleMaxSize"
                                    type="drag"
                                    :with-credentials="true"          
                                    :action="uploadUrl" 
                                    style="display: inline-block;width:200px; ">  
                                    <div style="padding: 1px 0;width:200px;height:130px;"   >
                                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                    </div>                                                                                                   
                                </Upload>
                                <div style="display:flex;margin-left:30px;flex-wrap:wrap"  >
                                    <span v-for="(item,index) in imgData.filter(item=>item.IMGTY=='PDF')" :key="index">  
                                        <div v-if="item.IMGPATH &&item.IMGPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                            <iframe :src="item.IMGPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                        </div> 
                                        <el-image  fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.IMGPATH" :preview-src-list="[item.IMGPATH]">
                                            <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                                        </el-image>
                                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                            <el-link :disabled="readFlag" :underline="false" @click="imgDel(item,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                            <el-link :underline="false" @click="downFile(item.IMGPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                                        </div>
                                    </span>
                                </div> 
                            </div>
                            <div class="one-div" style="height:28px;margin-top:5px">
                                <span  class="oneRow">{{ $LANG('1855', '入职申请表（请上传图片文件）') }}</span>
                            </div>
                            <div style="display:flex;margin-top:5px;height:150px;overflow-y:auto;" >
                                <Upload
                                    ref="upload"
                                    name="upfile"
                                    :data="uploadData"
                                    :show-upload-list="false"
                                    :before-upload="(file) =>beforeImgFile(file,'IMG')"
                                    :on-success="successImgFile"
                                    :on-progress="handleProgress"
                                    :max-size="10240"
                                    :on-exceeded-size="handleMaxSize"
                                    type="drag"
                                    :with-credentials="true"          
                                    :action="uploadUrl" 
                                    style="display: inline-block;width:200px; ">  
                                    <div style="padding: 1px 0;width:200px;height:130px;"  >
                                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                    </div>                                                                                                   
                                </Upload>
                                <div style="display:flex;margin-left:30px;flex-wrap:wrap"  >
                                    <span v-for="(item,index) in imgData.filter(item=>item.IMGTY=='IMG')" :key="index">  
                                        <div v-if="item.IMGPATH &&item.IMGPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                            <iframe :src="item.IMGPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                        </div> 
                                        <el-image  fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.IMGPATH" :preview-src-list="[item.IMGPATH]">
                                            <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                                        </el-image>
                                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                            <el-link :disabled="readFlag" :underline="false" @click="imgDel(item,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                            <el-link :underline="false" @click="downFile(item.IMGPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                                        </div>
                                    </span>
                                </div> 
                            </div>
                            <div class="one-div" style="height:28px;margin-top:5px">
                                <span  class="oneRow">{{ $LANG('1828', '身份证（请上传图片文件）') }}</span>
                            </div>
                            <div style="display:flex;margin-top:5px;height:150px;overflow-y:auto;" >
                                <Upload
                                    ref="upload"
                                    name="upfile"
                                    :data="uploadData"
                                    :show-upload-list="false"
                                    :before-upload="(file) =>beforeImgFile(file,'IMG2')"
                                    :on-success="successImgFile"
                                    :on-progress="handleProgress"
                                    :max-size="10240"
                                    :on-exceeded-size="handleMaxSize"
                                    type="drag"
                                    :with-credentials="true"          
                                    :action="uploadUrl" 
                                    style="display: inline-block;width:200px; ">  
                                    <div style="padding: 1px 0;width:200px;height:130px;"  >
                                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                    </div>                                                                                                   
                                </Upload>
                                <div style="display:flex;margin-left:30px;flex-wrap:wrap"  >
                                    <span v-for="(item,index) in imgData.filter(item=>item.IMGTY=='IMG2')" :key="index">  
                                        <div v-if="item.IMGPATH &&item.IMGPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                            <iframe :src="item.IMGPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                        </div> 
                                        <el-image  fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.IMGPATH" :preview-src-list="[item.IMGPATH]">
                                            <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                                        </el-image>
                                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                            <el-link :disabled="readFlag" :underline="false" @click="imgDel(item,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                            <el-link :underline="false" @click="downFile(item.IMGPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                                        </div>
                                    </span>
                                </div> 
                            </div>
                            <div class="one-div" style="margin-top:3px">
                                <span  class="oneRow">{{ $LANG('1835', '其它证明文件（不限制格式）') }}</span>
                            </div>
                            <div style="display:flex;margin-top:5px;height:150px;overflow-y:auto;" >
                                <Upload
                                    ref="upload"
                                    name="upfile"
                                    :data="uploadData"
                                    :show-upload-list="false"
                                    :before-upload="(file) =>beforeImgFile(file,'OTH')"
                                    :on-success="successImgFile"
                                    :on-progress="handleProgress"
                                    :max-size="10240"
                                    :on-exceeded-size="handleMaxSize"
                                    type="drag"
                                    :with-credentials="true"          
                                    :action="uploadUrl" 
                                    style="display: inline-block;width:200px; ">  
                                    <div style="padding: 1px 0;width:200px;height:130px;"  >
                                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                                    </div>                                                                                                   
                                </Upload>
                                <div style="display:flex;margin-left:30px;flex-wrap:wrap"  >
                                    <span v-for="(item,index) in imgData.filter(item=>item.IMGTY=='OTH')" :key="index">  
                                        <div v-if="item.IMGPATH &&item.IMGPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                            <iframe :src="item.IMGPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                        </div> 
                                        <el-image  fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.IMGPATH" :preview-src-list="[item.IMGPATH]">
                                            <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                                        </el-image>
                                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                            <el-link :disabled="readFlag" :underline="false" @click="imgDel(item,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                            <el-link :underline="false" @click="downFile(item.IMGPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                                        </div>
                                    </span>
                                </div> 
                            </div>
                        </div>
                    </span>
                    <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
                        <span style="float:right">
                            <span style="margin-right:30px;color:red;font-weight:600;font-size:12px ">{{ $LANG('1501', '提示：人员创建后，系统会自动以手机号码创建账号，初始密码为') }}2022</span>
                            <el-button type="info" @click="addModal=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                            <el-button :disabled="readFlag " @click="saveRec" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                        </span>
                    </div>  
                </el-dialog> 

            </div>
                <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                    </div> 
                    <div style="line-height:30px;display:flex">
                        <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                        <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                    </div>
                    <span slot="footer"  >
                        <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
                    </span>
                </el-dialog>
                <!-- 上传进度 -->
                <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                        <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
                    </div>
                    <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
                </el-dialog>
                <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
                    </div>
                    <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listUrl"></el-image>
                </el-dialog>
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
            </el-dialog>
            <!-- 引用报表 -->
            <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
                </div> 
                <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
            </el-dialog>      
            <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
            />
        </div>
        </template>
    </split-pane>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import {getDate} from '../../api/Select' 
import FileSaver from 'file-saver'
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
export default {
    name: 'hr_employee',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '4204',
            fieldIdseq: '4204',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            columnHiddenOptionKey: 'columnHiddenOption',
        })
    ],
    data () {
        return {
            repWin:false,
            repUrl:'',
            repDlg:false,
            repArr:[],
            v_stfg:'N',
            activeTab:'tab01',
            listUrl:'',
            operArr:[],
            addModal:false, //modal 
            oper:'like',
            readFlag:false, //查看标志
            prompt:'', // 
            promptWin:false,
            input_hold:this.$LANG('1670', '请输入内容')+'...',
            selparam:'IDNO',// select 绑定值
            txtparam:'', // input 绑定值
            allList:[],
            tabCol:[] ,//表列集合
            initCol:[],
            tabData:[] ,// 
            areaArr:[], //国家地区
            baseData:[] ,//表数据
            rcvData:[] ,// 收货地址数据
            orgData:[] ,//组织部门
            invData:[] ,// 发票数据
            invCol:[] ,//发票列集合
            disabled:false,
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
            showViewer:false,
            v_url:'xuper_auth/getTableRecMany' , //api请求路径    
            v_formgp:'xuper_auth/getFormGroup',   
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式    
            v_urlnum:'xuper_auth/getRecordCnt' ,  
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            loading:false,// table加载bool
            type:'create',
            ruleValidate: {},
            stfgBool:true,
            empNum:0,
            formCol:{}, //表格单行记录 model
            deptArr:[],
            notNull:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[] ,
            uploadData:{}, //上传数据
            dtlCol:[],
            dtlData:[],
            comboArr:{},
            chkIndex:'',
            delDtlData:[],
            v_saveFlag:true,
            formArr:[],
            v_row:{},
            pageIndex:1,
            loadingInstance: null,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_sort:'asc',
            vueCol:[],
            pageList: [100,500,1000],
            dataCount:0,
            pageSize:100,
            v_idno:'',
            v_replist:[],
            v_action:'',
            delData:[],
        }
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#hr_employee"),
                name: "wave",
            })
            this.getTabCol() //得到 表列数组 
            this.getFormData('','','') //初始查询表数据   
            this.getData() //表单 分组 数据  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    components: {
        repWin ,
        VeColumnConfigDialog,
    },
    mounted () {   
        this.$refs.refqry.focus()
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4204','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //国家地区
        getBaseData('xuper_auth/getCascadeData','parentno','308' ,'','','v_sys_base','').then(res=>{
            this.areaArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //部门选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_HR_DEPT','').then(res=>{
            this.deptArr =res.result
        })
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4204','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
        this.comSelect()
        //表单资料分组 
        getTabColOrData(this.v_formgp,'v_sys_form_fld','idseq','4204','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            this.formArr = res.result             
        })
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -155
        },
        tabWidth() {
          return (window.innerWidth - 120) + 'px';
        },
        scrollerHeight: function() {
            return (window.innerHeight - 95) + 'px';
        }, 
    },
    methods: {
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
        //排序
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },

        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }   
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        chkChange(){
            if (this.treeid =='0'|| this.parentid!=='0'){
                this.getFormData('',this.treeid,'')
            }else{
                this.getFormData('deptno',this.treeid,'')
            }
        },
        getRowKey(row){
            return row['IDSEQ']
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
        dtlDel(row,index){
            this.delDtlData.push(row)
            this.dtlData.splice(index,1)
        },
         //表格行 按回车键 到下一行
        nextLine(key,val ){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    v_count =this.dtlData.length                 
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    this.$refs[ this.chkIndex+'CNAME'][0].focus()  
                }else{
                    let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                    v_col.some((item,index)=>{
                        if (item.key==key){
                            this.$refs[ this.chkIndex+ v_col[index+1].key][0].focus()  
                        }
                    })
                } 
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1       
                if (this.chkIndex >=this.dtlData.length) {
                    this.chkIndex =0
                }
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])           
                this.$refs[this.chkIndex+key][0].focus()             
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }                            
                this.$refs[ this.chkIndex+key][0].focus()  
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])       
            }                    
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'4204', p_key3:'edcss',p_value3:'select',p_cond:' and lstseq in (2,1)'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        headStyle({row,column}){
            if (column.property=='TNMTH'||column.property=='DTTM'||column.property=='HR'){
                return 'color:red'
            }
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['STFG']!=='Y' ){
                return 'warning-row';
            }
        },
        getRowClick(row){
            this.chkIndex =row.index
        }, 
        getDtlKey(row){
            return row.index
        },
        downFile(fileName){
            const arr_name=fileName.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(fileName,file_name) 
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{ //
                let v_index =this.imgData.findIndex(x=>x['IDSEQ']==item['IDSEQ']&&x['LSTSEQ']==item['LSTSEQ'])
                this.imgData.splice(v_index, 1); 
                this.delData.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['IMGPATH']}) 
                   
            }).catch(()=>{})
        },
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }else{
                this.showViewer=true
                this.listUrl=path
            }
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' ' + this.$LANG('1561', '文件太大， 不能超出')+'10M'
        },
         //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name + this.$LANG('1431', '是不正确， 请选择图片或PDF格式')
        },
        imageFormatErrorSuffix () {
            const messages ={
                CN:'是不正确，请选择图片格式',
                EN:'is invalid. Please choose an image file.',
                YN:'không hợp lệ. Vui lòng chọn tệp hình ảnh.',
            }
            return messages[this.$store.state.lang] || messages.CN
        },
        handleImgError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name+' '+this.imageFormatErrorSuffix()
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        }, 
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({IMGPATH:this.$store.state.nasUrl+res.result,CNAME:file.name,IMGTY:this.v_action,PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }  
        },
 
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile ( file,v_code) {    
            this.v_action =v_code         
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
            if (data.id==='0'){
                this.getFormData('','','')
            }else{
                this.getFormData('deptno',data.id,'')
            }
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_HR_FRAME',p_cond:' and ( corpid=\''+this.v_corpid+'\')'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.orgData =res.result
                    // for (let k=0;k<res.result.length;k++){
                    //     vm.getDeptNum(res.result[k].id)
                    //     vm.orgData.push(Object.assign(res.result[k],{'label':res.result[k].label+'【'+vm.empNum+'】'}))
                    // }
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                    // console.log(JSON.stringify(vm.orgData))
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }            
            })                            
        },
 
        //表单确定按钮 两个特殊数据类型： null ,undefined 当为null时 用 ! ,为undefined 用 typeof
        saveRec(){
            //var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
            var telno=/^[1][3,4,5,6,7,8,9][0-9]{9}$/
            var vm =this
            let ctryno_=''
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })  
            if (this.stfgBool && this.v_saveFlag) {  
                if (telno.test(this.formCol['TELNO'])){
                    if (typeof(this.formCol['CTRYNO']) !=='string' ){
                        ctryno_ =this.formCol['CTRYNO'].join(',') 
                    }else{
                        ctryno_ =this.formCol['CTRYNO']
                    }
                    let v_dttmFlag =false, v_tnFlag =false  ,v_hrFlag=false
                    this.dtlData.forEach(item=>{
                        if (!item['TNMTH']){
                            v_tnFlag =true
                        }
                        if (!item['DTTM']){
                            v_dttmFlag =true
                        }
                        if (!item['HR']){
                            v_hrFlag =true
                        }
                    })   
                    if (v_tnFlag) {
                        this.promptWin =true
                        this.prompt =this.$LANG('1267', '明细资料中的')+(this.dtlCol.find(item=>item.key=='TNMTH')||{}).title+this.$LANG('2051', '不能为空')
                    }else if (v_dttmFlag) {
                        this.promptWin =true
                        this.prompt =this.$LANG('1267', '明细资料中的')+(this.dtlCol.find(item=>item.key=='DTTM')||{}).title+this.$LANG('2051', '不能为空')
                    }else if (v_hrFlag) {
                        this.promptWin =true
                        this.prompt =this.$LANG('1267', '明细资料中的')+(this.dtlCol.find(item=>item.key=='HR')||{}).title+this.$LANG('2051', '不能为空')
                    }else{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(Object.assign(vm.formCol,{CORPID:this.v_corpid,CTRYNO:ctryno_})), p_table:'HR_EMP',frmid:'4204'},
                        }).then(res=>{  
                            if(res.code ==='200')  {   
                                let v_idseq_ =res.idseq       
                                vm.addModal =false   
                                vm.qryTabData()
                                //3、图片保存
                                for(var k=0;k<this.imgData.length;k++){
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'bs_img',p_idseq:v_idseq_},
                                    })
                                } 
                                //删除服务器上的真实附件   
                                for(let k=0;k<this.delData.length;k++){
                                    let v_filepath=this.delData[k]['IMGPATH'],v_path=this.delData[k]['PATH']
                                    this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'idseq',p_value:this.delData[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delData[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delData[k]['IMGPATH'],p_table:'bs_img'},
                                    }).then(res=>{          
                                        //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                        if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                            this.$axios({
                                                method: 'post',
                                                url: '/xuper_oss/ftpDelete',
                                                data: {p_path:'/volume1'+v_path},
                                            }).then(res=>{ 
                                                console.log(res.result)
                                            })
                                        }
                                    })  
                                }   
                                //2.3、明细保存
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.dtlData), p_table:'HR_EMP_TRAIN',p_idseq:v_idseq_,p_action:'S'},
                                }) 
                                //2.4、明细删除
                                for (let k=0;k<this.delDtlData.length;k++) {
                                    this.$axios({   
                                        method: 'post',
                                        url:'xuper_auth/delTabRec',
                                        data: {p_key:'idseq',p_value: v_idseq_,p_key2:'lstseq',p_value2:this.delDtlData[k].LSTSEQ, p_table:'HR_EMP_TRAIN'  },
                                    }) 
                                } 
                                this.v_saveFlag =false
                            }else{
                                if (res.result.indexOf('ORA-00001')>-1){
                                    this.promptWin=true
                                    this.prompt=this.$LANG('1506', '手机号码已存在')
                                }else{
                                    this.promptWin=true
                                    this.prompt=res.result
                                }
                            }        
                        }) 
                    }
                }else{
                    this.promptWin=true
                    this.prompt=this.$LANG('1466', '错误的手机号码,请核查')
                }
            }
 
        },
        //查询其它标签内容
        queryEmpTab(idseq){
 
        },
        //新增记录
        addRec(){
            this.addModal =true
            this.type ='create'
            this.formCol ={'IDSEQ':'',STFG:'Y',SEX:'M',WORKTY:'全职',FACDTTM:getDate('day'),ISBUY:'Y'}
            this.readFlag =false
            this.imgData =[]
            this.dtlData =[]
            this.delDtlData=[]
        },
        //修改记录
        editRec(row,val){
            if (val==='R'){
                this.readFlag =true
                this.type ='read'
            }else{
                this.readFlag =false
                this.type ='edit'
            }
            let row_=''
            if (row.CTRYNO){
                try{
                    row_ =row.CTRYNO.split(',')
                    Object.assign(row,{CTRYNO:row_})
                }catch(err){
                    //    
                }
            }
           this.formCol=JSON.parse(JSON.stringify(row)) 
           this.addModal =true
           this.qryFileList(row['IDSEQ'])
           this.qryDtlData(row['IDSEQ'])
           this.delDtlData=[]
           this.v_saveFlag =true
        },
        qryFileList(idseq){
            this.imgData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:idseq,p_cond: ' order by SORTBY,LSTSEQ desc',p_table:'V_BS_IMG'},
            }).then(res=>{ 
                this.imgData =res.result
            })
        },
        qryDtlData(idseq){
            this.dtlData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:idseq,p_cond: ' order by dttm desc',p_table:'V_HR_EMP_TRAIN'},
            }).then(res=>{ 
                this.dtlData =res.result
            })
        },
        //查询选择器事件
        elchange(value){
            let obj ={}
            obj =this.tabCol.find(item=>{
                return item.key===value
            })
            this.input_hold=this.$LANG('1663', '请输入')+obj.title+this.$LANG('0363', ' 的值')
        },
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            let v_cond ='' , v_oper='=' ,v_oper2='like' ,v_edcss=''
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (this.v_row[`#OPER`+item]){
                        v_oper2 =this.v_row[`#OPER`+item]
                    }     
                    if (v_edcss =='number' ){
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                    }else if ( v_edcss=='date'){
                        v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_row[item] +'\''
                    }else{
                        if (v_oper2 =='='){
                            v_cond =v_cond +' and  '+item+' = \''+ (this.v_row[item]).trim()+'\''  
                        }else{
                            v_cond =v_cond +' and '+item+' like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }
                }
            })
            if (this.treeid =='0'|| this.parentid!=='0'){
                this.getFormData('',this.treeid,cond_+v_cond)
            }else{
                this.getFormData('deptno',this.treeid,cond_+v_cond)
            }
        },
 
        //获取表单数据
        getFormData( deptid,deptval,cond){
            var vm=this
            this.loading =true
            let v_cond =this.v_stfg=='Y'?' and stfg=\'N\'':' and stfg=\'Y\''
            getTabColOrData(this.v_formurl,'v_HR_EMP','corpid',this.v_corpid,deptid,deptval,'','',cond+v_cond+' order by '+this.selparam).then((res) => {              
                if (res.code==='200'){
                    this.allList=res.result    
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.initPage()
                vm.loading =false         
            });            
        },
        getDeptNum(deptval){
            getTabColOrData(this.v_urlnum,'v_HR_EMP','corpid',this.v_corpid,'deptno',deptval ).then((res) => {              
                if (res.code==='200'){
                    this.empNum=res.result    
                }      
            });            
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','LSTSEQ','1' ).then((res) => {
                vm.initCol =res.result
                return vm.loadInitialFieldSettings().then(() => {
                const fieldRows =vm.sortFieldRows(vm.initCol)
                vm.tabCol =[]
                vm.vueCol =[]
                for (let k=0; k<fieldRows.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(fieldRows[k], vm.$store.state.lang),
                        key: fieldRows[k].key,
                        thide: fieldRows[k].THIDE,
                        fhide: fieldRows[k].FHIDE,
                        disabled: fieldRows[k].DISABLED,
                        align: fieldRows[k].align,
                        width: fieldRows[k].width,
                        edcss: fieldRows[k].EDCSS,
                        sortable: fieldRows[k].SORTABLE,
                    })
                    let itcol =fieldRows[k]
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>                                                    
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <el-date-picker v-model={this.v_row[column.key]} value-format="yyyy-MM-dd" size="mini"  placeholder="yyyy-mm-dd" style="width:100%" on-change={()=>this.qryTabData() }  ></el-date-picker> 
                                                         
                                            </div>
                                        </div>                                   
                                    )
                                } else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.qryTabData() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                                </div>
                                            </div>                                   
                                        )
                                    }else if (itcol.EDCSS =='checkbox') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-select  placeholder="请选择"   v-model={this.v_row[column.key]}   on-change={()=>this.qryTabData() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini">
                                                        <el-option label={this.$LANG('2047', '是')} value="Y"></el-option>
                                                        <el-option label={this.$LANG('2044', '否')} value="N"></el-option>
                                                    </el-select> 
                                                </div>
                                            </div>                                   
                                        )

                                    } else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.qryTabData() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                                </div>
                                            </div>                                   
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'  ){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('0293', '在职')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('0367', '离职')}</el-tag> )
                                    }                                          
                                }else if (column.key=='IDNO') { //procShow(scope.row)
                                    return (
                                        <el-link  title=""  on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width: 110,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ( 
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link   on-click={()=>{this.editRec(row,'R' )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={this.editBool} on-click={()=>{this.editRec(row,'E' )}}  underline={false} ><span style="font-size:12px;margin-right:2px;">{this.$LANG('1639', '编辑')}</span></el-link>
                            </div>                                
                        )
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                vm.applyFieldSettingRows()
                return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        sortable: res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
</style>
<style lang="less">
 
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;  
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .warning-row  {
        color: red;
    }
        
    .el-cascader-panel{
        height: 60vh;
        .el-scrollbar__wrap{
            height:100%;
        }
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>
